function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon_-_return_button",
  "data-name": "icon - return button",
  transform: "translate(0.92 9.952)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "frame",
  width: 64,
  height: 64,
  transform: "translate(-0.92 -9.952)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2487",
  "data-name": "Path 2487",
  d: "M11.222,40.381a.97.97,0,0,1-.523-1.787l41.558-26.5A.97.97,0,0,1,53.3,13.727l-41.557,26.5a.969.969,0,0,1-.521.152",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2488",
  "data-name": "Path 2488",
  d: "M11.005,8.627a14.692,14.692,0,0,0,2.6-.373c1.167-.306,1.362-1.514.589-1.954,0,0-3.844-.339-5.335-.343A3.912,3.912,0,0,0,6.281,7.206a1.039,1.039,0,0,1-.914.294L2.547,7a.843.843,0,0,0-.977.684L.983,11.018a.843.843,0,0,0,.684.977l2.884.508a1.039,1.039,0,0,1,.755.584A3.683,3.683,0,0,0,7.983,15.2l6.582,1.161",
  transform: "translate(-0.919 -5.951)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2489",
  "data-name": "Path 2489",
  d: "M14.4,17.32,7.816,16.159A4.628,4.628,0,0,1,4.429,13.5L1.5,12.95a1.815,1.815,0,0,1-1.47-2.1L.616,7.518a1.817,1.817,0,0,1,2.1-1.47l2.82.5A5.011,5.011,0,0,1,8.852,4.988H8.86c1.515,0,5.259.331,5.417.346a.971.971,0,0,1,.394.123,1.853,1.853,0,0,1,.937,1.883A2.259,2.259,0,0,1,13.85,9.193a15.679,15.679,0,0,1-2.8.4.989.989,0,0,1-1.013-.923.97.97,0,0,1,.923-1.014,13.966,13.966,0,0,0,2.4-.342.68.68,0,0,0,.221-.1c-1.1-.092-3.614-.292-4.723-.294h0a2.992,2.992,0,0,0-1.885.964A2.01,2.01,0,0,1,5.2,8.455L2.5,7.98,1.96,11.062l2.76.487a2,2,0,0,1,1.463,1.124,2.716,2.716,0,0,0,1.97,1.576l6.581,1.161Z",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2490",
  "data-name": "Path 2490",
  d: "M30,22.589,9.822,19.03a.92.92,0,0,1-.746-1.066L11.637,3.439,33.631,7.317,31.07,21.843A.92.92,0,0,1,30,22.589",
  transform: "translate(-0.919 -5.951)",
  fill: "#c7c7c7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2491",
  "data-name": "Path 2491",
  d: "M30.165,23.573a1.934,1.934,0,0,1-.329-.029h0L9.653,19.985A1.893,1.893,0,0,1,8.12,17.8L10.683,3.27a.971.971,0,0,1,1.123-.787L33.8,6.362a.967.967,0,0,1,.786,1.123L32.024,22.011a1.892,1.892,0,0,1-1.859,1.562M12.424,4.562,10.03,18.133l20.094,3.492L32.508,8.1Z",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2492",
  "data-name": "Path 2492",
  d: "M33.631,7.317,11.637,3.439l.3-1.708A.919.919,0,0,1,13,.985L33.186,4.543a.921.921,0,0,1,.746,1.066Z",
  transform: "translate(-0.919 -5.951)",
  fill: "#c7c7c7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2493",
  "data-name": "Path 2493",
  d: "M33.632,8.287a.965.965,0,0,1-.169-.015L11.469,4.394a.969.969,0,0,1-.786-1.124l.3-1.707A1.888,1.888,0,0,1,13.172.03L33.354,3.588a1.891,1.891,0,0,1,1.534,2.189l-.3,1.709a.97.97,0,0,1-.954.8m-20.9-5.64L32.845,6.193l.133-.752L12.835,1.94Z",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2494",
  "data-name": "Path 2494",
  d: "M7.837,10.3s2.4.387,3.168-1.676a15.216,15.216,0,0,0,3.2-.266c1.166-.306,1.362-1.515.588-1.955,0,0-4.447-.445-5.937-.449",
  transform: "translate(-0.919 -5.951)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2495",
  "data-name": "Path 2495",
  d: "M8.3,11.306a3.961,3.961,0,0,1-.613-.046.97.97,0,0,1,.3-1.916A1.921,1.921,0,0,0,10.1,8.287a1,1,0,0,1,.927-.63,13.843,13.843,0,0,0,2.937-.235.659.659,0,0,0,.229-.1c-1.2-.115-4.2-.392-5.333-.394a.97.97,0,0,1,0-1.94h0c1.521,0,5.849.435,6.033.454a.973.973,0,0,1,.382.122,1.855,1.855,0,0,1,.937,1.883A2.255,2.255,0,0,1,14.453,9.3a13.514,13.514,0,0,1-2.844.3A3.789,3.789,0,0,1,8.3,11.306",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2496",
  "data-name": "Path 2496",
  d: "M31.606,18.8,22.412,17.18a.551.551,0,0,1-.447-.638L23.013,10.6a.551.551,0,0,1,.638-.447l9.194,1.622Z",
  transform: "translate(-0.919 -5.951)",
  fill: "#0ff497"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2497",
  "data-name": "Path 2497",
  d: "M31.606,19.77a.952.952,0,0,1-.168-.014l-9.194-1.622a1.523,1.523,0,0,1-1.234-1.759l1.049-5.943a1.506,1.506,0,0,1,.623-.98A1.522,1.522,0,0,1,23.82,9.2l9.194,1.621a.971.971,0,0,1,.786,1.124l-1.239,7.025a.969.969,0,0,1-.955.8M22.993,16.3l7.826,1.38.9-5.115L23.9,11.182Zm.976-5.53v0Z",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2498",
  "data-name": "Path 2498",
  d: "M52.084,34.491l-15.459,3V48.847a.623.623,0,0,0,.442.6l10.052,3.075a.94.94,0,0,0,.453.024l14.953-2.9a.624.624,0,0,0,.506-.613V38.187a.623.623,0,0,0-.442-.6L52.537,34.515a.94.94,0,0,0-.453-.024",
  transform: "translate(-0.919 -5.951)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2499",
  "data-name": "Path 2499",
  d: "M47.393,53.529a1.921,1.921,0,0,1-.559-.083L36.782,50.371a1.586,1.586,0,0,1-1.128-1.524V37.493a.97.97,0,0,1,.785-.952l15.459-3a1.927,1.927,0,0,1,.924.049l10.051,3.074A1.587,1.587,0,0,1,64,38.187V49.026a1.6,1.6,0,0,1-1.292,1.565l-14.953,2.9a1.835,1.835,0,0,1-.362.035m-9.8-4.938,9.809,3,14.658-2.85v-10.3l-9.8-3L37.593,38.293Zm24.747.1h0ZM52.252,35.442h0Zm-.169-.951h0Z",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2500",
  "data-name": "Path 2500",
  d: "M52.313,34.447,36.624,37.493V27.768a.624.624,0,0,1,.506-.613l14.439-2.8a.625.625,0,0,1,.744.613Z",
  transform: "translate(-0.919 -5.951)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2501",
  "data-name": "Path 2501",
  d: "M36.624,38.463a.969.969,0,0,1-.97-.97V27.768A1.6,1.6,0,0,1,36.945,26.2l14.439-2.8a1.594,1.594,0,0,1,1.9,1.565v9.482a.97.97,0,0,1-.785.952l-15.69,3.046a.956.956,0,0,1-.184.018m.969-10.41v8.264l13.75-2.67V25.383Zm14.72,6.394h0Z",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_21",
  "data-name": "Line 21",
  x1: 8.066,
  y2: 1.566,
  transform: "translate(45.463 30.991)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2502",
  "data-name": "Path 2502",
  d: "M46.382,39.478a.969.969,0,0,1-.184-1.921l8.067-1.567a.97.97,0,0,1,.369,1.9L46.568,39.46a.985.985,0,0,1-.186.018",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_22",
  "data-name": "Line 22",
  x1: 10.718,
  y1: 3.278,
  transform: "translate(35.705 31.542)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2503",
  "data-name": "Path 2503",
  d: "M47.342,41.742a.969.969,0,0,1-.284-.043L36.34,38.42a.97.97,0,0,1,.568-1.854l10.718,3.279a.97.97,0,0,1-.284,1.9",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2504",
  "data-name": "Path 2504",
  d: "M47.342,52.472v-11.7l15.173-2.946",
  transform: "translate(-0.919 -5.951)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2505",
  "data-name": "Path 2505",
  d: "M47.342,53.442a.97.97,0,0,1-.97-.97v-11.7a.97.97,0,0,1,.785-.952l15.174-2.947a.97.97,0,0,1,.369,1.9L48.312,41.571v10.9a.97.97,0,0,1-.97.97",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2506",
  "data-name": "Path 2506",
  d: "M50.885,40.095V51.9l9.129-1.773V38.322Z",
  transform: "translate(-0.919 -5.951)",
  fill: "#0ff497"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2507",
  "data-name": "Path 2507",
  d: "M50.884,52.869a.969.969,0,0,1-.969-.969V40.094a.968.968,0,0,1,.785-.951l9.128-1.773a.97.97,0,0,1,1.155.952V50.127a.97.97,0,0,1-.785.952l-9.129,1.772a.893.893,0,0,1-.185.018m.97-11.975v9.83l7.189-1.4V39.5Z",
  transform: "translate(-0.919 -5.951)",
  fill: "#414143"
}));

function SvgIconTakePackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTakePackage);
export default __webpack_public_path__ + "static/media/icon-take-package.9f1dccee.svg";
export { ForwardRef as ReactComponent };